import {useState} from 'react';
import {SupportSlotDefinitionModel} from '../../../../model/support/slot/support-slot-definition.model';
import {
  SupportSlotDefinitionPreviewCustomersTabState,
  useSupportSlotDefinitionPreviewCustomersTabState
} from './support-slot-definition-preview-customers-tab-state';
import {
  SupportSlotDefinitionPreviewDetailsTabState,
  useSupportSlotDefinitionPreviewDetailsTabState
} from './support-slot-definition-preview-details-tab-state';

export type SupportSlotDefinitionPreviewDrawerState = {
  currentTab: number
  setCurrentTab: (value: number) => void
  detailsTabState: SupportSlotDefinitionPreviewDetailsTabState
  customersTabState: SupportSlotDefinitionPreviewCustomersTabState
}

export const useSupportSlotDefinitionPreviewDrawerState = (initialSlotDefinition: SupportSlotDefinitionModel): SupportSlotDefinitionPreviewDrawerState => {
  const detailsTabState = useSupportSlotDefinitionPreviewDetailsTabState(initialSlotDefinition)
  const customersTabState = useSupportSlotDefinitionPreviewCustomersTabState(initialSlotDefinition.id)

  const [currentTab, setCurrentTab] = useState(0);

  return {
    detailsTabState: detailsTabState,
    customersTabState: customersTabState,
    currentTab: currentTab,
    setCurrentTab: setCurrentTab
  }
}